<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { recordingStoppedNotification } from './notifications'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    props: [
      'channel'
    ],
    created () {
      this.channel.bind('recording.stopped', () => {
        this.markRecordingState('stopped')
        this.markRecordingButtonDisabled(false)
        recordingStoppedNotification().show()
      })
    },
    methods: mapActions([
      'markRecordingState',
      'markRecordingButtonDisabled'
    ])
  }
</script>



// WEBPACK FOOTER //
// recording-stopped.vue?673aa7f9